import styled from 'styled-components';

import { TextUs } from 'src/app/components/Elements/Location';

import Button from '../../../Elements/Button';

export const HeadingTwo = styled.h2`
  font-size: ${props => props.theme.fontSizes.headerTwo} !important;
  padding-bottom: ${props => props.theme.space.s2} !important;
`;

export const Subtitle = styled.div<{ maxWidthDesktop?: string }>`
  font-size: ${props => props.theme.fontSizes.small} !important;
  font-weight: ${props => props.theme.fontWeights.semiBold} !important;
  font-family: ${props => props.theme.fonts.circular};
  color: ${props => props.theme.colors.capsuleBlue50};
  ${props => (props.maxWidthDesktop ? `max-width: ${props.maxWidthDesktop};` : ``)}
  ${props => props.theme.mediaQueries.smallDown} {
    max-width: none;
  }
`;

export const SubtitleBlock = styled.span`
  display: inline-block;
  ${props => props.theme.mediaQueries.smallDown} {
    display: block;
  }
`;

export const SmallMedNameTitle = styled.p`
  font-size: ${props => props.theme.fontSizes.body} !important;
  color: ${props => props.theme.colors.capsuleBlue50} !important;
`;

export const IconWrapper = styled.div`
  flex: none;
  margin-right: ${props => props.theme.space.s3};
`;

export const Border = styled.hr`
  margin: ${props => props.theme.space.s5} ${props => props.theme.space.none};
  border: none;
  border-bottom: ${props => props.theme.borderWidths.small} solid ${props => props.theme.colors.capsuleGreen10};
`;

export const InlineBlockContent = styled.span`
  display: inline-block;
`;

export const StyledLink = styled.a`
  color: ${props => props.theme.colors.capsuleGreen60}!important;
  &:hover {
    text-decoration: underline;
  }
  font-family: ${props => props.theme.fonts.circular};
  font-size: ${props => props.theme.fontSizes.body} !important;
  line-height: ${props => props.theme.lineHeights.body} !important;
  font-weight: ${props => props.theme.fontWeights.book};
`;

export const StyledButton = styled(props => <Button {...props} />)`
  margin: 0;
`;

export const LinkStyleButton = styled.button`
  font: inherit;
  border: none;
  cursor: pointer;
  background: transparent;
  color: ${props => props.theme.colors.capsuleGreen60};
  &:hover {
    text-decoration: underline;
  }
`;

export const StyledTextUsLink = styled(TextUs)`
  color: ${props => props.theme.colors.capsuleGreen60}!important;
`;
